module.exports = __webpack_public_path__ + "static/img/image_support_video_cover_01.f60335f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_video_cover_01.png
// module id = sWBw
// module chunks = 10